<template>
    <v-snackbar :color="t.color" top left v-model="t.show" dark>
        <v-icon v-if="t.color === 'success'" color="white" class="mr-3">
            mdi-check
        </v-icon>
        <v-icon v-if="t.color === 'error'" color="white" class="mr-3">
            mdi-alert-circle-outline
        </v-icon>
        <div>{{t.text}}</div>
    </v-snackbar>
</template>

<script>
    import {mapState} from 'vuex';
    export default {
        name: "Toast",
        computed: {
            ...mapState("app", ["toast"]),
            t: {
                get() {
                    return this.toast;
                }
            }
        }
    }
</script>
